import { Component, OnDestroy, OnInit, AfterViewInit, ViewContainerRef, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { environment } from '@env/environment';
import { MenuService } from '@app/services/menu.service';
import { PlatformService } from '@app/services/platform.service';
import { FamilyService } from '@app/services/family.service';
import { merge, of, Subject, combineLatest } from 'rxjs';
import { GlobalConfigService, WaitingRoomService } from '@app/services';
import { HeaderService } from '@app/services/header.service';
import { HeaderConfig } from '@app/models/global-config';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged, filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  modeDebug = environment.modeDebug;
  previousUrl: string;
  destroy$ = new Subject<void>();
  reservationsToPay: number;
  waitingRoomNotifierDisplay: boolean;
  config: HeaderConfig;
  hideBackButton: boolean;
  panierButtonAnimationClass: Array<string> = []
  isMobile: boolean;

  constructor(
    private globalConfigService: GlobalConfigService,
    public familyService: FamilyService,
    private titleService: Title,
    private translateService: TranslateService,
    private router: Router,
    public menuService: MenuService,
    public platformService: PlatformService,
    public headerService: HeaderService,
    private waitingRoomService: WaitingRoomService
  ) {
  }

  ngOnInit() {

    this.platformService.isMobile$.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe(value => this.isMobile = value)

    this.globalConfigService.getPart<HeaderConfig>('header').subscribe(conf => {
      this.config = conf;
      this.headerService.setFavicon(conf.favicon);
    });

    this.headerService.favicon$.subscribe(icon => this.writeFavicon(icon));

    combineLatest([
      this.headerService.pageTitle$.pipe(
        switchMap((pageTitle) => pageTitle ? this.translateService.get(pageTitle) : of(''))),
      this.headerService.inAdmin$
    ]).subscribe(([pageTitle, inAdmin]) => {
      if (inAdmin) {
        this.titleService.setTitle('⚙ ' + pageTitle)
      } else {
        this.titleService.setTitle(pageTitle)
      }
    });

    this.waitingRoomService.inRestrictedRoom$.subscribe(val => {
      this.waitingRoomNotifierDisplay = val
    })
  }

  ngAfterViewInit() {
    this.familyService.reservationsToPay$.subscribe(rp => {
      setTimeout(() => { // prevent error NG0100: Expression has changed after it was checked
        this.reservationsToPay = rp
        setTimeout(() => {
          this.animatePanierButton()
        }, 500)
      });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  writeFavicon(url: string) {
    // find all icons, including "apple-touch-icon"
    const favHeaders = document.querySelectorAll('link[rel~="icon"]');

    if (favHeaders.length) {
      favHeaders.forEach(tag => tag.setAttribute('href', url));
    }
  }

  startPreventBackButtonDetection() {
    merge(
      of(this.router.url),
      this.router.events.pipe(
        filter(e => e instanceof NavigationEnd),
        map((e: NavigationEnd) => e.url))
    ).pipe(
      map(url => url.startsWith('/') ? url.substring(1) : url),
      takeUntil(this.destroy$),
    ).subscribe(url => this.hideBackButton = ['home', ''].includes(url));
  }

  onBack() {
    history.back();
  }

  animatePanierButton() {
    this.panierButtonAnimationClass.push('anim-hey')
    setTimeout(() => { this.panierButtonAnimationClass = this.panierButtonAnimationClass.filter(c => c !== 'anim-hey') }, 2000)
  }
}
